const { constants } = require('@config');
const { default: tableQuery } = require('assets/js/editor/table/table-query');
const { getFontStretch } = require('assets/js/editor/text/text-helpers');
const { calculateColumnsWidth } = require('assets/js/helpers/columnsHelper');
const { convertPixelToRem } = require('src/utils/toolbelt');

const DesignFacade = require('../../../../facade/design/design');
const FontsFactory = require('../../../../factory/fonts');

module.exports = Backbone.View.extend({
  initialize: function ($elem, buttonSelect, popupMenuCommonFunctions, defaultMenus) {
    this.$elem = $elem;
    this.popupMenuCommonFunctions = popupMenuCommonFunctions;
    this.buttonSelect = buttonSelect;
    this.defaultMenus = defaultMenus;
    this.canvas = INKIVE.Tool.getInstance().editor.canvas;
    this.hasLibrary = popupMenuCommonFunctions.hasLibrary;

    _.bindAll(this, 'drawTextMenuItems', 'updateToolbarButtonsAppliedFlag', 'updateToolbarForResizing', 'toggleAppliedClass', 'drawTextBlockActions', 'updateFontStyle',
      'updateTextAnchor', 'initSliders', 'drawHeadings', 'drawFontSizes', 'isContainsSubset', 'getFontSubsetByLocale', 'sortByLocale',
      'drawFontNames', 'drawFontGroup', 'drawAFont', 'drawFontLocaleSelector', 'isLocaleSubsetSelected',
      'drawLibraryFonts', 'toggleFontLibraryMenu', 'addLibraryItems', 'onFavFontsPreload', 'prependFav',
      'buildFontMenu', 'filterFont', 'importCSSFonts');

    INKIVE.DesignFacade.on('font-variant.update', (arg) => this.highlightSelectedFont(arg));
  },

  drawTextMenuItems: function () {
    const isTextEdit = this.canvas.getMode() === 'textedit';

    // Replace old text
    if (this.$elem.find('>g.textGroup, >text').length) {
      new INKIVE.Text.Textarea().setDOM(this.$elem[0]).render(this.canvas);
    }

    this.$elem.popupmenu({ buttons: this.defaultMenus[(isTextEdit ? 'TEXT_EDIT' : 'TEXT')] });

    this.drawTextBlockActions(isTextEdit);
    this.highlightSelectedFont();

    INKIVE.EditorFacade.on('text.selection_changed', this.updateToolbarButtonsAppliedFlag);
    INKIVE.EditorFacade.on('text.resized', this.updateToolbarForResizing);
  },

  // Called when user edits a textbox or sets cursor (triggers event 'text.selection_changed')
  updateToolbarButtonsAppliedFlag: function (buttonsFlagData) {
    // Prevent processing the same event multiple times
    if (buttonsFlagData.processed) { return; }
    buttonsFlagData.processed = true;

    // A utility function to assign/remove 'applied' class to/from formatting buttons (Bold, Italic, Underline)
    function setFormattingButtonFlag (dataAction, shouldBeApplied) {
      const formattingButton = document.querySelector(`[data-action="${dataAction}"]`);
      if (!formattingButton) return;
      if (shouldBeApplied) {
        formattingButton.classList.contains('applied') || formattingButton.classList.add('applied');
      } else {
        formattingButton.classList.contains('applied') && formattingButton.classList.remove('applied');
      }
    }

    function updateSlider (button, flagValue) {
      if (button) {
        button.value = flagValue;
        const slider = $(button.parentNode).find('.slider');
        slider && slider.slider('value', flagValue);
      }
    }

    setFormattingButtonFlag('on_set-bold', buttonsFlagData.isBold);
    setFormattingButtonFlag('on_set-italic', buttonsFlagData.isItalic);
    setFormattingButtonFlag('on_set-underline', buttonsFlagData.isUnderlined);
    setFormattingButtonFlag('on_set-bullets', buttonsFlagData.bullets);
    setFormattingButtonFlag('on_set-list', buttonsFlagData.ordered);
    setFormattingButtonFlag('on_set-link', !!buttonsFlagData.link);

    const inputSetFontSize = document.querySelector('[data-action="on_fontsize"] input');
    if (inputSetFontSize) {
      inputSetFontSize.value = buttonsFlagData.fontSize === '?'
        ? '?'
        : Math.precision(buttonsFlagData.fontSize, 2);
    }

    const spanFontFamilyTitle = document.querySelector('[data-action="on_fontfamily"] span.ui-dropdown-title');
    if (spanFontFamilyTitle) {
      spanFontFamilyTitle.textContent = buttonsFlagData.fontFamily;
    }

    const spanHeadingTitle = document.querySelector('[data-action="on_heading"] span.ui-dropdown-title');
    if (spanHeadingTitle) {
      spanHeadingTitle.textContent = isNaN(buttonsFlagData.heading) ? 'Text Block' : `Heading ${buttonsFlagData.heading}`;
    }

    const buttonSetColor = document.querySelector('[data-action="colormap-circle"] i.desygner-icon-fill');
    if (buttonSetColor && buttonsFlagData.fill) {
      buttonSetColor.style.color = buttonsFlagData.fill;
      const inputSetColor = document.querySelector('[data-action="colormap-circle"] .color-selector-input');
      if (inputSetColor) {
        inputSetColor.value = buttonsFlagData.fill.substr(1);
        inputSetColor.dispatchEvent(new Event('keyup'));
      }
    }

    const textButtonColor = document.querySelector('[type="fill"][data-action="colormap-circle"] icon > svg');
    if (textButtonColor && buttonsFlagData.fill) {
      textButtonColor.style.fill = buttonsFlagData.fill;
      const inputSetColor = document.querySelector('[data-action="colormap-circle"] .color-selector-input');
      if (inputSetColor) {
        inputSetColor.value = buttonsFlagData.fill.substr(1);
      }
    }

    const highlightButton = document.querySelector('[type="highlight"][data-action="colormap-circle"] icon > svg');
    if (highlightButton) {
      highlightButton.style.fill = buttonsFlagData.highlight;
    }

    switch (buttonsFlagData.textAnchor) {
      case 'start':
        this.toggleAlignmentAppliedClass('left');
        break;
      case 'middle':
        this.toggleAlignmentAppliedClass('center');
        break;
      case 'end':
        this.toggleAlignmentAppliedClass('right');
        break;
      case 'justify_start':
        this.toggleAlignmentAppliedClass('justify_start');
        break;
      case 'justify_middle':
        this.toggleAlignmentAppliedClass('justify_middle');
        break;
      case 'justify_end':
        this.toggleAlignmentAppliedClass('justify_end');
        break;
      case 'justify_all':
        this.toggleAlignmentAppliedClass('justify_all');
        break;
      default:
        break;
    }

    const paragraphSpacingButton = document.querySelector('input#paragraphSpacing');
    const firstLineMarginButton = document.querySelector('input#firstLineMargin');
    const rightMarginButton = document.querySelector('input#rightMargin');
    const lineMarginButton = document.querySelector('input#lineMargin');
    const lineSpacingButton = document.querySelector('input#lineSpacing');
    const charSpacingButton = document.querySelector('input#charSpacing');

    updateSlider(paragraphSpacingButton, buttonsFlagData.paragraphSpacing);
    updateSlider(firstLineMarginButton, buttonsFlagData.firstLineMargin);
    updateSlider(rightMarginButton, buttonsFlagData.rightMargin);
    updateSlider(lineMarginButton, buttonsFlagData.lineMargin);
    updateSlider(lineSpacingButton, buttonsFlagData.lineSpacing);
    updateSlider(charSpacingButton, buttonsFlagData.letterSpacing);

    this.highlightSelectedFont(buttonsFlagData.fontFamily, buttonsFlagData.fontWeight, buttonsFlagData.fontStretch, buttonsFlagData.fontStyle);
  },

  // Called when user resizes a textbox (triggers event 'text.resized')
  updateToolbarForResizing: function (data) {
    const inputSetFontSize = document.querySelector('[data-action="on_fontsize"] input');
    if (inputSetFontSize) {
      inputSetFontSize.value = Math.precision(data.newFontSize, 2);
    }
  },

  drawTextBlockActions: function (isTextEdit) {
    const selectedElement = this.$elem[0];
    const tableCell = selectedElement.parentElement;
    const isTableCell = tableCell?.classList?.contains('table-cell');
    const textAttr = new INKIVE.Text.Textarea().setDOM(selectedElement, false);
    const tablePadding = tableQuery.getCellPadding(tableCell);

    const range = this.canvas.runExtensions('selectionRange', {});
    this.styles = textAttr.text.getStyles4Range(range.start, range.end);
    this.styles.heading = textAttr.heading;

    this.drawHeadings();
    this.drawFontSizes();
    this.drawFontNames();
    this.updateTextAnchor(textAttr);

    // We will toggle applied classes for table in table-menu-items.js
    if (isTableCell && !isTextEdit) {
      this.initTableSliders(textAttr, tablePadding);
    } else {
      this.initSliders(textAttr, tablePadding);
      this.updateFontStyle(textAttr);
    }
  },

  updateFontStyle: function (textAttr) {
    this.toggleAppliedClass('on_set-bold',
      (this.styles.font_weight === 'bold' || parseInt(this.styles.font_weight) >= 700));
    this.toggleAppliedClass('on_set-italic', this.styles.font_style === 'italic');
    this.toggleAppliedClass('on_set-underline', this.styles.text_decoration === 'underline');

    textAttr.text.bullets && this.toggleAppliedClass('on_set-bullets', true);
    textAttr.text.ordered && this.toggleAppliedClass('on_set-list', true);
  },

  updateFillColor: function () {
    this.buttonSelect('colormap-circle').find('i.desygner-icon-fill').css('color', this.styles.fill);
    const textInput = this.buttonSelect('colormap-circle').find('.color-selector-input');

    textInput.val(this.styles.fill.substr(1));
    textInput.trigger('keyup');
  },

  updateTextAnchor: function (textAttr) {
    if (!this.buttonSelect('on_text-align').length) {
      return;
    }

    const isRtl = textAttr.text.direction === 'rtl';

    switch (textAttr.text.text_anchor) {
      case 'start' :
        this.toggleAppliedClass('on_set-align-left', true);
        this.buttonSelect('on_text-align').find('use').get(0).setAttribute('xlink:href', '#text---align-' + (isRtl ? 'right' : 'left'));
        break;
      case 'middle' :
        this.toggleAppliedClass('on_set-align-center', true);
        this.buttonSelect('on_text-align').find('use').get(0).setAttribute('xlink:href', '#text---align-center');
        break;
      case 'end' :
        this.toggleAppliedClass('on_set-align-right', true);
        this.buttonSelect('on_text-align').find('use').get(0).setAttribute('xlink:href', '#text---align-' + (isRtl ? 'left' : 'right'));
        break;
      case 'justify_start' :
        this.toggleAppliedClass('on_set-align-justify_start', true);
        this.buttonSelect('on_text-align').find('use').get(0).setAttribute('xlink:href', '#text---align-justify-start');
        break;
      case 'justify_middle' :
        this.toggleAppliedClass('on_set-align-justify_middle', true);
        this.buttonSelect('on_text-align').find('use').get(0).setAttribute('xlink:href', '#text---align-justify-middle');
        break;
      case 'justify_end' :
        this.toggleAppliedClass('on_set-align-justify_end', true);
        this.buttonSelect('on_text-align').find('use').get(0).setAttribute('xlink:href', '#text---align-justify-end');
        break;
      case 'justify_all' :
        this.toggleAppliedClass('on_set-align-justify_all', true);
        this.buttonSelect('on_text-align').find('use').get(0).setAttribute('xlink:href', '#text---align-justify-all');
        break;
    }
  },

  initTableSliders: function (textAttr, tablePadding) {
    const firstLineMargin = Math.max(Number(textAttr.text.first_line_margin) - tablePadding.left, 0) || 0;
    const margin = Number(textAttr.text.line_margin) - tablePadding.left || 0;
    const rightMargin = Number(textAttr.text.right_margin) - tablePadding.right || 0;
    // Spacing for whole text
    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-cell-paragraph-spacing'),
      'paragraphSpacing', textAttr.text.paragraph_spacing, -10, 200
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-cell-line-spacing'),
      'lineSpacing', textAttr.text.line_spacing, -10, 100
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-cell-word-spacing'),
      'wordSpacing', textAttr.text.word_spacing, 0, 100
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-cell-letter-spacing'),
      // For most RTL texts, letter spacing must be larger than font size to take effect
      'charSpacing', textAttr.text.letter_spacing, -5, 200
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-cell-first-line-margin'),
      'firstLineMargin', firstLineMargin, 0, 200
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-cell-line-margin'),
      'lineMargin', margin, 0, 200
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-cell-right-margin'),
      'rightMargin', rightMargin, 0, 200
    );
  },

  initSliders: function (textAttr, tablePadding) {
    const maxMargin = 200;
    const minMargin = 0;
    const minGap = constants.text.columns.minGap;
    const maxGap = constants.text.columns.maxGap;

    const columnsWidth = calculateColumnsWidth(textAttr.width, textAttr.text.columns, textAttr.text.columns_gap);
    const minColumnsWidth = calculateColumnsWidth(textAttr.width, textAttr.text.columns, maxGap);
    const maxColumnsWidth = calculateColumnsWidth(textAttr.width, textAttr.text.columns, minGap);

    const letterSpacing = Array.isArray(textAttr.text.letter_spacing) ? textAttr.text.letter_spacing[0] : textAttr.text.letter_spacing;
    const firstLineMargin = Math.max(Number(textAttr.text.first_line_margin) - tablePadding.left, 0) || 0;
    const margin = Number(textAttr.text.line_margin) - tablePadding.left || 0;
    const rightMargin = Number(textAttr.text.right_margin) - tablePadding.right || 0;

    // Spacing for whole text
    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-paragraph-spacing'),
      'paragraphSpacing', textAttr.text.paragraph_spacing, -10, 200
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-line-spacing'),
      'lineSpacing', textAttr.text.line_spacing, -10, 100
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-word-spacing'),
      'wordSpacing', textAttr.text.word_spacing, 0, 100
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-char-spacing'),
      // For most RTL texts, letter spacing must be larger than font size to take effect
      'charSpacing',
      convertPixelToRem(letterSpacing, textAttr.text.font_size).toFixed(0) || 0,
      constants.text.spacing.minLetterSpacing,
      constants.text.spacing.maxLetterSpacing
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-paragraph-char-spacing'),
      'charSpacing',
      textAttr.text.letter_spacing,
      constants.text.spacing.minLetterSpacing,
      constants.text.spacing.maxLetterSpacing
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-first-line-margin'),
      'firstLineMargin', firstLineMargin, minMargin, maxMargin
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-right-margin'),
      'rightMargin', rightMargin, minMargin, maxMargin
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-line-margin'),
      'lineMargin', margin, minMargin, maxMargin
    );

    // Spacing for editing text
    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-paragraph-spacing-dy'),
      'paragraphSpacing', textAttr.text.paragraph_spacing, -10, 200
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-paragraph-first-line-margin'),
      'firstLineMargin', firstLineMargin, minMargin, maxMargin
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-paragraph-margin'),
      'lineMargin', margin, minMargin, maxMargin
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-paragraph-right-margin'),
      'rightMargin', rightMargin, minMargin, maxMargin
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-paragraph-dy'),
      'lineSpacing', textAttr.text.line_spacing, -10, 100
    );

    // Column slider
    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-column-number'),
      'columnNumber', textAttr.text.columns, 1, 4
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-column-gap'),
      'columnGap', textAttr.text.columns_gap, minGap, maxGap
    );

    this.popupMenuCommonFunctions.initSliderElement(
      this.buttonSelect('on_set-column-width'),
      'columnWidth',
      columnsWidth,
      minColumnsWidth,
      maxColumnsWidth
    );
  },

  drawHeadings: function () {
    const $container = this.buttonSelect('on_heading');
    const list = INKIVE.TemplatesHelper('popupmenu_heading_list');

    const headingList = ['Text Block', 'Heading 1', 'Heading 2', 'Heading 3', 'Heading 4', 'Heading 5'];

    $container.find('.ui-dropdown-items').empty().append(list);
    _.bind(addSizeInput, this)();

    $container.find('.ui-dropdown-title').html(headingList[Number(this.styles.heading)] || headingList[0]);

    INKIVE.Helpers.initTooltips($container);

    function addSizeInput () {
      $container.find('input').remove();
    }
  },

  drawFontSizes: function () {
    const $container = this.buttonSelect('on_fontsize');
    const list = INKIVE.TemplatesHelper(
      'popupmenu_font_size_list',
      getFontSizes()
    );

    $container.find('.ui-dropdown-items').empty().append(list);
    _.bind(addSizeInput, this)();

    function getFontSizes () {
      const fontSizes = [];

      for (let i = 8; i <= 56; i += 2) fontSizes.push(i);
      fontSizes.push(62, 74, 86, 98, 110, 122, 134, 146, 158);

      return fontSizes;
    }

    function addSizeInput () {
      $container.find('input').remove();
      const $title = $container.find('.ui-dropdown-title').hide();
      const $input = $('<input>');

      $input.val(Math.precision(this.styles.font_size, 1)).insertBefore($title);

      $input.on('keyup', _.debounce(applySizeChanges, 500));
      $input.on('keydown', function (event) {
        if (event.which === 13) {
          event.preventDefault();
          applySizeChanges(event);
        }
      });

      function applySizeChanges () {
        const $target = $input.parents('.ui-dropdown');
        const val = parseFloat($input.val());

        if (_.isNumber(val)) {
          $input.val(val || '');
          val && $target.trigger('change', [val]);
        }
      }
    }
  },

  isContainsSubset: function (fontData) {
    return $.inArray(this.getFontSubsetByLocale(), fontData.support.subsets) > -1;
  },

  getFontSubsetByLocale: function () {
    const locale = INKIVE.Helpers.cookieStorage.get('locale');
    let fontSubset;
    if (this.$elem.data('font-locale-subset')) {
      fontSubset = this.$elem.data('font-locale-subset');
    } else {
      fontSubset = null;
      _.each(INKIVE.C.LOCALE_SUBSETS, function (obj) {
        if ($.inArray(locale, obj.locales) > -1) {
          fontSubset = obj.name;
        }
      });
    }
    return fontSubset || 'default';
  },

  sortByLocale: function (a, b) {
    return ((this.isContainsSubset(a) === this.isContainsSubset(b)) ? 0 : this.isContainsSubset(a) ? -1 : 1) ||
      a.family.toLowerCase().localeCompare(b.family.toLowerCase());
  },

  drawFontNames: function () {
    const $container = this.buttonSelect('on_fontfamily');

    this.buildFontMenu($container);

    const fontData = FontsFactory.get(this.styles.font_family);
    const name = fontData && fontData.isSystem
      ? 'PDF font'
      : this.styles.font_family.replace(/^'(.*)'$/, '$1').replace(/\\'/g, '\'');

    fontData && fontData.isSystem && this.canvas.call('advice.show', 'pdf-text');

    $container.find('.ui-dropdown-title').html(name);

    INKIVE.Helpers.initTooltips($container);
  },

  importCSSFonts: function (delta) {
    delta = parseInt(delta) ? delta : 0;
    const desygnerFonts = [];
    const clientHeight = $('#content')[0].getBoundingClientRect().height;
    const $container = $('a[data-action=on_fontfamily]');

    $container.find('a[data-type=all]').each(function () {
      const y = this.getBoundingClientRect().y;

      (y > 0 && y < clientHeight + delta) && desygnerFonts.push({
        family: $(this).data('font-family'),
        customId: $(this).data('custom-id')
      });
    });

    FontsFactory.importDesignCSSFonts(desygnerFonts);
  },

  getFontMenu: function () {
    return $('#element-popupmenu').find('a[data-action=on_fontfamily] > .fullscreen');
  },

  buildFontMenu: function ($container) {
    const $fontMenu = $('#element-popupmenu').find('>.fullscreen ');

    this.getFontMenu().attr('id', 'font-menu-list');
    if ($fontMenu.length) {
      this.getFontMenu().append($fontMenu.children());

      $fontMenu.remove();
      return;
    }

    $container.append('<i class="desygner-icon-arrow-down"/>');
    $container.on('mousedown', () => {
      const usableFonts = FontsFactory.getUsableFonts().filter(fontData => !fontData.isSystem || !fontData.isEmbedded);

      const isLibraryFont = function (fontData) {
        return !fontData.isSystem && fontData.customId;
      };

      const isRegularFont = function (fontData) {
        return !fontData.isSystem && !(fontData.customId || fontData.templateFonts);
      };

      let regularFonts = _.filter(usableFonts, isRegularFont);
      this.libraryFonts = _.sortBy(_.uniq(_.filter(usableFonts, isLibraryFont), function (elem) {
        return elem.family;
      }), 'family').filter(font => !font.isDeleted);

      let fontsPresent = Array.from(document.querySelector('#svgcontent').querySelectorAll('[font-family]'))
        .map((e) => e.getAttribute('font-family').replace(/^'|'$/g, ''));
      fontsPresent = [...new Set(fontsPresent)];

      let recentFonts = [];

      this.libraryFonts.concat(usableFonts).forEach((f) => {
        fontsPresent.includes(f.family) &&
        !recentFonts.find((e) => e.family === f.family) &&
        !f.isDeleted &&
        recentFonts.push(f);
      });

      if (this.libraryFonts.length === 1) {
        recentFonts = recentFonts.filter(f => !this.libraryFonts.includes(f));
      }

      regularFonts = _.filter(regularFonts, this.isLocaleSubsetSelected);

      this.fontNamesHeader = $('<div class="ui-dropdown-font-names-header">');
      this.fontNames = $('<ul>');

      recentFonts.sort(this.sortByLocale);
      regularFonts.sort(this.sortByLocale);

      INKIVE.RestrictionsFacade.isFunctionalityAllowed('function_use_desygner_font') && this.drawFontLocaleSelector();
      this.hasLibrary && this.addLibraryItems();

      this.addFontSearch();

      if (!this.fontNamesHeader.find('.ui-font-selection').length) {
        this.fontNamesHeader.find('.ui-dropdown-font-library-icon').css('margin-top', 20);
        this.fontNamesHeader.find('.ui-dropdown-font-search').css('margin-top', 60);
      }

      this.drawFontGroup(recentFonts, 'popupmenu.font_title.recent');
      this.drawFontGroup(this.libraryFonts, 'popupmenu.font_title.library');
      this.drawFontGroup(regularFonts, 'popupmenu.font_title.all');

      const libraryFontsHtml = this.$libraryFontsContainer ? this.$libraryFontsContainer[0].outerHTML : '';

      const scrollHandlers = '<section class="up"><i class="icon-chevron-up"></i></section>' +
        '<section class="down"><i class="icon-chevron-down"></i></section>';

      this.getFontMenu().append(this.fontNamesHeader);
      this.getFontMenu().append(this.fontNames);
      this.getFontMenu().append(scrollHandlers);
      this.getFontMenu().append(libraryFontsHtml);

      this.highlightSelectedFont();

      DesignFacade.off('text.update.font').on('text.update.font', _.bind(function (font) {
        if (!font || !font.family) return;
        const fontMenu = this.getFontMenu();

        // Add font to recent fonts (if it's not already there)
        const fontQuery = `[data-font-family="${font.family}"]`;
        const fontElement = fontMenu[0].querySelector(fontQuery);
        let recentFontElement = fontMenu[0].querySelector(`${fontQuery}[data-is-recent-font]`);

        if (!recentFontElement) {
          recentFontElement = fontMenu[0].querySelector(`${fontQuery}[data-type="recent"]`);
        }

        if (this.libraryFonts.length > 1 && fontElement && !recentFontElement) {
          recentFontElement = fontElement.parentElement.cloneNode(true);
          recentFontElement.firstChild.dataset.isRecentFont = true;
          const recentFonts = fontMenu[0].querySelector('div[data-type=recent]');
          recentFonts.parentNode.insertBefore(recentFontElement, recentFonts.nextSibling);
        }

        FontsFactory.importDesignCSSFonts(FontsFactory.get(font.family)).then(() => {
          INKIVE.EditorFacade.trigger('fonts.added', font.family);
        });

        const textAttr = new INKIVE.Text.Textarea().setDOM(this.$elem[0]);
        const range = this.canvas.runExtensions('selectionRange', {});
        this.styles = textAttr.text.getStyles4Range(range.start, range.end);
        this.addFontMenuEvents($container);
        fontMenu.find('>ul').css('top', '100px');
        fontMenu.find('input').val('').trigger('keyup');

        this.highlightSelectedFont();
      }, this));

      this.addFontMenuEvents($container);
      $container.off('mousedown').off('fonts-shown').on('fonts-shown', this.importCSSFonts);
    });
  },

  highlightSelectedFont: function (defaultFontFamily, defaultFontWeight, defaultFontStretch, defaultFontStyle) {
    const styles = this.styles;
    const fontFamily = defaultFontFamily?.replace(/^'|'$/g, '') || styles.font_family.replace(/^'|'$/g, '');
    const fontStretch = defaultFontStretch || styles.font_stretch || 'normal';
    const fontStyle = defaultFontStyle || styles.font_style || 'normal';

    const $fonts = this.getFontMenu().find(`[data-font-family="${fontFamily}"]`);

    this.getFontMenu().find('[data-font-family]').parent().removeClass('selected-font');
    $fonts.each((i, item) => {
      const $item = $(item);

      // if (customFontSourceId) {
      //   $item.is('[data-custom-font-source-id=' + customFontSourceId + ']') && $item.parent().addClass('selected-font');
      // }
      let fontWeight = defaultFontWeight || styles.font_weight || '';

      if (!fontWeight || fontWeight.toLowerCase() === 'normal') fontWeight = '400';

      const matchStyle = $item.is(`[data-font-style=${fontStyle}]`) && $item.is(`[data-font-stretch=${fontStretch}]`) && $item.is(`[data-font-weight=${fontWeight}]`);

      ($item.parent().is('.font-family-container') || matchStyle) &&
      $item.parent().addClass('selected-font');
    });
  },

  drawFontGroup: function (fonts, title) {
    const type = title.replace('popupmenu.font_title.', '');
    const $title = $('<div class="ui-dropdown-font-group-title" data-type="' + type + '">' +
      '<span>' + INKIVE.TranslateHelper.translate(title) + '</span>' +
      '</div>').css('display', 'none');
    this.fontNames.append($title);

    _.each(fonts, _.bind(function (font) {
      this.drawAFont(FontsFactory.get(font.family), null, type);
    }, this));
  },

  addLibraryItems: function () {
    const isEmpty = _.isEmpty(this.libraryFonts);
    const tooltip = INKIVE.TranslateHelper.translate('popupmenu.font_title.' + (isEmpty ? 'empty_library' : 'library'));
    const $libraryItemsIcon = $('<div class="ui-dropdown-font-library-icon" data-popover="tooltip"' +
      ' data-placement="bottom"/>');

    $libraryItemsIcon.append($('<i class="desygner-icon-folder"></i>'));
    $libraryItemsIcon.attr('data-original-title', tooltip);
    $libraryItemsIcon.toggleClass('disabled-icon', isEmpty);

    this.fontNamesHeader.append($libraryItemsIcon);

    this.drawLibraryFonts();
  },

  addFontSearch: function () {
    const $fontSearchContainer = $('<div class="ui-dropdown-font-search"/>');
    const $fontSearchInput = $('<input type="text" placeholder="' +
      INKIVE.TranslateHelper.translate('popupmenu.font_title.search_font') + '"/>');

    $fontSearchContainer.append($fontSearchInput);
    $fontSearchContainer.append($('<i class="desygner-icon-search"/>'));

    this.fontNamesHeader.append($fontSearchContainer);
  },

  filterFont: function (event) {
    const $fonts = $('.fullscreen>ul>li');
    const $ul = $fonts.parent();

    $fonts.find('>a').each(function () {
      const $this = $(this);
      $this.parent().toggle($this.html().toLowerCase().indexOf($(event.target).val().toLowerCase()) > -1);
    });

    $ul.find('div[data-type]').hide();
    $fonts.each(function () {
      const $this = $(this);
      $this.is(':visible') && $ul.find('div[data-type=' + $this.find('a').data('type') + ']').show();
    });

    $ul.css('top', 100);
    $ul.siblings('.up').hide();

    _.delay(this.importCSSFonts, 100);
  },

  drawAFont: function (fontData, container, type) {
    const $container = container || this.fontNames;
    const variants = fontData.support.variants || ['400'];
    const isOneVariant = variants.length === 1;
    const lang = '';
    let subs = '';
    const keys = [];
    $container.find('div[data-type=' + type + ']').css('display', 'block');

    isOneVariant || $.each(fontData.support.variants,
      function (i, option) {
        let { variant, id, tooltip, weight, style, name } = typeof option === 'string' ? { variant: option } : option;

        const source = fontData?.support?.sources?.find(s => s.id === id);
        const stretch = getFontStretch(source?.width?.toLowerCase());

        if (!weight) {
          weight = parseInt(variant);
        }

        if (!name) {
          name = fontData.family;
          name += ' ' + weight;

          if (variant.indexOf('italic') > -1) {
            name += ' Italic';
          }

          tooltip = '';
        }

        const fontStyle = source?.slope?.toLowerCase() || style || variant.includes('italic') ? 'italic' : 'normal';

        keys.push(variant);

        subs += `<li data-popover="tooltip" data-original-title="${tooltip}" data-title="${tooltip}">
                  <a role="menuitem" data-font-family="${fontData.family}" data-font-weight="${weight}" data-font-stretch="${stretch || 'normal'}" data-font-style="${fontStyle}"
                  style="display: flex; width: 100%; overflow: hidden; font-family: '${fontData.family.replace(/'/g, "\\'")}'; font-weight: ${weight}; font-stretch: ${stretch || 'normal'}; font-style: ${fontStyle};"
                  data-custom-font-source-id="${id}">${name}</a></li>`;
      });

    let sub = '';
    let cls = '';
    let arrow = '';
    if (jQuery.grep(keys, function (n) {
      return (n !== 700);
    }).length > 0) {
      sub = '<section class="ui-dropdown-items sub font-variant"><ul>' + subs + '</ul></section>';
      cls = ' class="dropdown-hover"';
      arrow = '<i class="arrow icon-chevron-right"></i>';
    }

    let { id, weight, variant } = isOneVariant ? variants[0] : { variant: '400', weight: 400 };
    if (!weight) {
      weight = parseInt(variant);
    }

    const customId = fontData.customId ? 'data-custom-id=' + fontData.customId : '';
    const fontSourceId = id ? ' data-custom-font-source-id="' + id + '"' : '';

    $container.append($('<li  class="font-family-container" >' +
      lang + '<a data-type="' + type + '" role="menuitem" ' + cls + ' style="' +
      'font-family: \'' + fontData.family.replace(/'/g, '\\\'') + '\'; font-weight: ' + weight +
      '" data-font-family="' + fontData.family + '" data-font-weight="' + weight + '" ' + customId + fontSourceId +
      '><span class="font-family-link-container">' + fontData.family + '</span></a>' + arrow + sub + '</li>'));
    $container.find('[data-popover="tooltip"]:not(.tooltip-initialized)').tooltip().addClass('tooltip-initialized');
  },

  drawFontLocaleSelector: function () {
    const keys = [];

    const fontLocaleSubset = this.getFontSubsetByLocale();
    const selectedFontLocale = fontLocaleSubset || 'default';
    const localeTitle = {
      default: INKIVE.TranslateHelper.translate('popupmenu.font_locale.languages.title.default'),
      arabic: 'Arabic',
      bengali: 'Bengali',
      chinese: '中国',
      cyrillic: 'кириллица',
      devanagari: 'Devanagari',
      greek: 'ελληνικά',
      gujarati: 'Gujarati',
      gurmukhi: 'Gurmukhi',
      hebrew: 'עברי',
      kannada: 'Kannada',
      khmer: 'Khmer',
      korean: '한국의',
      japanese: '日本の',
      'latin-ext': 'Latin Ext',
      malayalam: 'Malayalam',
      myanmar: 'Myanmar',
      oriya: 'Oriya',
      sinhala: 'Sinhala',
      tamil: 'Tamil',
      telugu: 'Telugu',
      thai: 'Thai',
      vietnamese: 'Vietnamese'
    };

    const $fontSelectionContainer = $('<section class="ui-font-selection"/>');
    const $antiScrollWrap = $('<section class="ui-dropdown-items antiscroll-wrap"/>');
    const $antiScrollInner = $('<section class="antiscroll-inner"/>');
    const $ul = $('<ul/>');
    const $link = $('<a role="menuitem"  class="dropdown-hover">' + localeTitle[selectedFontLocale] + '</a>');

    $.each(INKIVE.C.LOCALE_SUBSETS, function (i, fontLocale) {
      function hasFontLocaleSubset (fontData) {
        return _.contains(fontData.support.subsets, fontLocale.name);
      }

      if (fontLocale.name === 'default' ||
        _.filter(FontsFactory.get(), hasFontLocaleSubset, 'latin').length) {
        keys.push(fontLocale.name);

        const tooltip = INKIVE.TranslateHelper.translate('popupmenu.font_locale.languages.tooltip.' + fontLocale.name);

        $ul.append($('<li class="font-locale' + (selectedFontLocale === fontLocale.name ? ' selected' : '') + '">' +
          '<a data-font-locale-subset="' + fontLocale.name + '" role="menuitem" data-popover="tooltip" ' +
          'data-original-title="' + tooltip + '" data-title="' + tooltip + '" data-placement="right">' +
          localeTitle[fontLocale.name] +
          '</a></li>'));
      }
    });

    $antiScrollWrap.append($antiScrollInner);
    $antiScrollInner.append($ul);

    this.fontNamesHeader.append($('<div class="ui-dropdown-all-languages-title">' +
      INKIVE.TranslateHelper.translate('popupmenu.font_locale.title') +
      '</div>'));

    $fontSelectionContainer.append($link);
    $fontSelectionContainer.append($('<i class="desygner-icon-arrow-down"></i>'));
    $fontSelectionContainer.append($antiScrollWrap);

    this.fontNamesHeader.append($fontSelectionContainer);
  },

  drawLibraryFonts: function () {
    this.$libraryFontsContainer = $('<section class="ui-font-library-container"/>');

    const $iconsContainer = $('<div class="ui-dropdown-font-library-icons"/>');

    $iconsContainer.append('<div class="ui-dropdown-font-library-icon"><i class="desygner-icon-folder"></i></div>');
    const $backIcon = $('<div class="ui-dropdown-font-library-back-icon"><i class="desygner-icon-back"></i></div>');
    $iconsContainer.append($backIcon);

    this.$libraryFontsContainer.append($iconsContainer);

    const $ul = $('<ul/>');
    const $title = $('<section class="ui-dropdown-font-group-title" data-type="library-fonts" >' +
      '<span>' + INKIVE.TranslateHelper.translate('popupmenu.font_title.library') + '</span>' +
      '</section>');

    _.each(this.libraryFonts, _.bind(function (font) {
      this.drawAFont(font, $ul, $title.data('type'));
    }, this));

    this.$libraryFontsContainer.append($title);
    this.$libraryFontsContainer.append($ul);
    $ul.after('<section class="down"><i class="icon-chevron-down"></i><section>')
      .after('<section class="up"><i class="icon-chevron-up"></i><section>');
  },

  addAntiScroll: function ($wrapper) {
    $wrapper.antiscroll({
      autoHide: false,
      width: $wrapper.width(),
      height: $wrapper.height()
    });
  },

  addFontMenuEvents: function ($container) {
    this.toggleFontLibraryMenu(false);

    $container.find('.ui-font-selection').off('click').on('click', _.bind(function (e) {
      const $target = $(e.target);

      if ($target.parents().andSelf().is('.ui-dropdown-items.antiscroll-wrap')) {
        const fontLocaleSubset = $target.data('font-locale-subset') ||
          $target.find('>[data-font-locale-subset]').data('font-locale-subset');

        if (fontLocaleSubset) {
          this.getFontMenu().remove();
          INKIVE.EditorFacade.canvas.runExtensions('reloadFontLocaleSubset', fontLocaleSubset);
        }
      } else {
        this.getFontMenu().find('.ui-font-selection .antiscroll-wrap').toggle();
      }

      this.addAntiScroll($('.ui-font-selection .antiscroll-wrap'));

      e.stopPropagation();
    }, this));

    const $fontWithVariants = $container.find('.ui-dropdown-items.sub').parent();

    $fontWithVariants.off('mouseenter').on('mouseenter', this.toggleSubContainer);
    $fontWithVariants.off('mouseleave').on('mouseleave', this.toggleSubContainer);

    $container.find('.ui-dropdown-items.fullscreen>ul, .ui-font-library-container>ul').each(_.bind(function (idx, ul) {
      const $ul = $(ul);
      const scrollEvent = 'DOMMouseScroll mousewheel scroll';

      $ul.off(scrollEvent).on(scrollEvent, _.bind(function (e) {
        const oEvent = e.originalEvent;
        if (e.target.closest('.font-variant')) {
          return;
        }

        if (!$(e.target).parents('.ui-font-selection').length) {
          $('.ui-font-selection').find('.ui-dropdown-items').find('.sub').hide();
          this.scroll($ul, (oEvent.deltaY || oEvent.wheelDelta));
        }
      }, this));

      $ul.siblings('.up').off('click').on('click', _.bind(function () {
        this.scroll($ul, -500);
      }, this));

      $ul.siblings('.down').off('click').on('click', _.bind(function () {
        this.scroll($ul, 500);
      }, this));
    }, this));

    const $libraryFontIcon = $container.find('.ui-dropdown-font-names-header .ui-dropdown-font-library-icon');

    $libraryFontIcon.off('click').on('click', _.bind(function (e) {
      if ($libraryFontIcon.is('.disabled-icon')) { return; }

      this.toggleFontLibraryMenu(true);

      e.stopPropagation();
    }, this));

    const $backLibraryIcon = $container.find('.ui-dropdown-font-library-back-icon');
    $backLibraryIcon.off('click').on('click', _.partial(this.toggleFontLibraryMenu, false));

    $container.find('.ui-dropdown-font-search input[type=text]').off('keyup').on('keyup', this.filterFont);
  },

  toggleSubContainer: function (event) {
    const menuItem = event.target.closest('li');
    const show = event.type === 'mouseenter';
    const sub = menuItem.querySelector('.ui-dropdown-items.sub');
    const container = menuItem.closest('.fullscreen');

    if (!container.dataset.originalWidth) {
      container.dataset.originalWidth = getComputedStyle(container).width;
    }
    let newWidth = parseFloat(container.dataset.originalWidth);

    container.querySelectorAll('.sub').forEach((s) => { s.style.display = 'none'; });

    if (show) {
      newWidth += parseFloat(getComputedStyle(sub).width);
      sub.style.display = 'block';

      const header = document.querySelector('header');
      const headerBoundingRect = header.getBoundingClientRect();
      const subItemBoundingRect = sub.getBoundingClientRect();
      const menuItemBoundingRect = menuItem.getBoundingClientRect();

      if (menuItemBoundingRect.top < window.innerHeight / 2) {
        if (menuItemBoundingRect.top + subItemBoundingRect.height + headerBoundingRect.height > window.innerHeight) {
          sub.style.top = `${(window.innerHeight - headerBoundingRect.height - subItemBoundingRect.height) - menuItemBoundingRect.top}px`;
        } else {
          sub.style.top = '0';
        }

        sub.style.bottom = 'initial';
      } else {
        if (menuItemBoundingRect.bottom - subItemBoundingRect.height < headerBoundingRect.bottom) {
          sub.style.bottom = `${menuItemBoundingRect.bottom - (subItemBoundingRect.height + headerBoundingRect.height)}px`;
        } else {
          sub.style.bottom = '0';
        }
        sub.style.top = 'initial';
      }
    }

    container.style.width = newWidth + 'px';
  },

  scroll: function ($ul, delta) {
    const ulTop = $ul.offset().top;
    const lastTop = $ul.find('>li:visible:last').offset().top;

    const $comboBox = $('.ui-dropdown-items.fullscreen');
    let top = ulTop - delta - 50;
    const comboBoxHeight = $comboBox.height();

    if (top > 100) {
      top = 100;
    } else if (lastTop - delta < comboBoxHeight) {
      top = ulTop - (lastTop - comboBoxHeight) - 100;
    }

    if (top <= 100) {
      $ul.css({ top });
      $comboBox.find('.up').toggle(top !== 100);
    }

    this.importCSSFonts(delta);
  },

  toggleFontLibraryMenu: function (show) {
    const $fontLibraryContainer = this.getFontMenu().parent().find('.ui-font-library-container');

    this.getFontMenu().parent().find('>.down').toggle(!show);
    const $up = this.getFontMenu().parent().find('>.up');
    $up.hide();
    !show && parseInt(this.getFontMenu().parent().find('>ul').css('top')) < 100 && $up.show();

    $fontLibraryContainer.toggle(show);

    show && this.getFontMenu().find('.ui-font-selection .ui-dropdown-items').hide();
  },

  isLocaleSubsetSelected: function (fontData) {
    if (this.getFontSubsetByLocale() === 'default' && fontData.support.isDefault) {
      return fontData;
    } else if (this.isContainsSubset(fontData)) {
      return fontData;
    }
  },

  onFavFontsPreload: function () {
    const isAdded = this.buttonSelect('on_fontfamily') && this.buttonSelect('on_fontfamily')
      .find('.ui-dropdown-items ul li hr').length;

    if (INKIVE.Tool._cache.favFonts.length && !isAdded) {
      this.prependFav('on_fontsize', 'fontSize', function (size) {
        return '<li><a role="menuitem">' + Math.precision(size, 1) + ' pt</a></li>';
      });

      this.prependFav('on_fontfamily', 'fontFamily', function (val) {
        return '<li><a role="menuitem" style="font-family: ' + val + ';" font-family="' + val + '">' + val + '</a></li>';
      });
    }
  },

  toggleAppliedClass: function (selector, applied) {
    this.buttonSelect(selector).toggleClass('applied', applied);
  },

  toggleAlignmentAppliedClass: function (textAnchor) {
    const alignmentOptions = ['right', 'left', 'center', 'justify_start', 'justify_middle', 'justify_end', 'justify_all'];
    alignmentOptions.forEach(alignment => {
      const alignmentButton = document.querySelector(`[data-action="on_set-align-${alignment}"]`);
      alignmentButton && alignmentButton.classList.toggle('applied', false);
    });

    const alignButton = document.querySelector(`[data-action="on_set-align-${textAnchor}"]`);
    const alignIcon = document.querySelector('[data-action="on_text-align"] use');

    alignButton && alignButton.classList.toggle('applied', true);
    if (textAnchor.includes('justify')) textAnchor = textAnchor.replace('_', '-');
    alignIcon && alignIcon.setAttribute('xlink:href', `#text---align-${textAnchor}`);
  },

  prependFav: function (action, attr, map) {
    const $button = this.buttonSelect(action);
    if (!$button) return;

    const $ul = $button.find(' > .ui-dropdown-items > ul');
    const html = _.map(this.getProcessedValues(attr), map).join('');

    $ul.prepend(html);
  },

  getProcessedValues: function (attr) {
    return _(INKIVE.Tool._cache.favFonts).chain()
      .flatten()
      .pluck(attr)
      .unique()
      .value()
      .reverse();
  }
});
